// extracted by mini-css-extract-plugin
export default {"root":"PressBoilerplate--root--qRNyD"};